export const AiAgentsRoute = {
  AIAGENT: 'aiagents',
};

export const AiAgentsPathName = {
  AIAGENT: 'aiagents',
};

export const AiAgentsListId = 'AiAgentsList';
